import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { delay } from 'rxjs';

import { PopularBetsExpandCollapseService } from '../popular-bets-services/popular-bets-expand-collapse.service';
import { IExpandCollapse } from '../popular-bets.models';

@Component({
    imports: [NgTemplateOutlet, IconCustomComponent],
    selector: 'ms-popular-bets-pod-show-more',
    templateUrl: './popular-bets-pod-show-more.component.html',
    styleUrls: ['./popular-bets-pod-show-more.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularBetsPodShowMoreComponent implements OnInit {
    @Input() totalCount: number;
    @Input() defaultCount: number;
    @Input() isEpcotEnabled: boolean;
    @Output() expandChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    private destroyRef = inject(DestroyRef);
    private waitTillTransition = 300;
    showMoreLessText: string;
    isExpanded: boolean;

    constructor(
        private sitecorePopularBetsConfig: SitecorePopularBetsConfig,
        private popularBetsExpandCollapseService: PopularBetsExpandCollapseService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.showMoreLessText = this.getShowMoreLessText();
        this.popularBetsExpandCollapseService
            .getExpandCollapse()
            .pipe(delay(this.waitTillTransition), takeUntilDestroyed(this.destroyRef))
            .subscribe((data: IExpandCollapse) => {
                this.isExpanded = this.totalCount <= data.noOfLegs;
                this.showMoreLessText = this.getShowMoreLessText();
                this.changeDetectorRef.detectChanges();
            });
    }

    onShowMoreLessButtonToggle(): void {
        this.expandChange.emit(!this.isExpanded);
    }

    private getShowMoreLessText(): string {
        if (this.isExpanded) {
            return interpolateDoubleBracesString(this.sitecorePopularBetsConfig.messages?.Hide, { noOfLegs: this.totalCount - this.defaultCount });
        }

        return interpolateDoubleBracesString(this.sitecorePopularBetsConfig.messages?.SeeAll, { noOfLegs: this.totalCount });
    }
}
